import TemporaryBloodPressureHackedGraph from './TemporaryBloodPressureHackedGraph'

export default TemporaryBloodPressureHackedGraph



// WEBPACK FOOTER //
// ./src/legacy/containers/Graphs/TemporaryBloodPressureHackedGraph/index.js